function base() {
	initMenu();
	initPreviousReports();
	initTooltips();
	initRevealOnScrollAnimations();
	initCookies();
	initBreadcrumbs();

	let rellax = new Rellax('.rellax', {
		center: true,
	});
}
